import { render, staticRenderFns } from "./ModalSelectStudy.vue?vue&type=template&id=4e93e01f&scoped=true"
import script from "./ModalSelectStudy.vue?vue&type=script&lang=js"
export * from "./ModalSelectStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e93e01f",
  null
  
)

export default component.exports